import React, { useEffect } from 'react';
import { useMap } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet.heat';

interface HeatmapLayerProps {
    points: [number, number, number][];
}

const HeatmapLayer: React.FC<HeatmapLayerProps> = ({ points }) => {
    const map = useMap();

    useEffect(() => {
        if (points && points.length > 0) {
            console.log('HeatmapLayer: Adding', points.length, 'points to map');
            console.log('Sample points:', points.slice(0, 5));

            // Configuration améliorée pour la heatmap avec des valeurs plus visibles
            const heat = L.heatLayer(points, {
                radius: 50,      // Augmenté de 30 à 50 pour une meilleure visibilité
                blur: 25,        // Augmenté de 20 à 25
                maxZoom: 16,     // Réduit de 17 à 16
                max: 1.0,
                minOpacity: 0.3, // Ajout d'une opacité minimale
                gradient: {
                    0.0: 'blue',
                    0.25: 'cyan',
                    0.5: 'lime',
                    0.75: 'yellow',
                    1.0: 'red'
                }
            }).addTo(map);

            // Animation de fondu lors de l'ajout
            const container = map.getContainer();
            container.style.opacity = '0';
            setTimeout(() => {
                container.style.transition = 'opacity 0.5s ease-in';
                container.style.opacity = '1';
            }, 100);

            return () => {
                map.removeLayer(heat);
            };
        }
    }, [map, points]);

    return null;
};

export default HeatmapLayer;
